import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/Text/Text.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/Text/Text.ts';

export const prototypeName = '7r30pQPgwki19ozAWL5JflaRRQpnoeFwq6R6weAjT4ep2agao6i90r08Gla0UQ1Ay0n';
export {styles};
export {script};